<template>
  <a
    ref="link"
    :class="$style.link"
    :href="href"
    :target="target"
    @click="handleLinkClick"
  >
    <slot />
  </a>
</template>

<script>
/* eslint no-script-url: 0 */

export default {
  name: 'TextLink',
  props: {
    copyOnClick: {
      type: Boolean,
      default: true,
    },
    href: {
      type: String,
      default: 'javascript:void(0);',
    },
    onCopySuccess: {
      type: Function,
      default: () => {},
    },
    target: {
      type: String,
      default: '_blank',
    },
  },

  methods: {
    /**
     * Creates a text field with the text value from the link so that we can select and copy it.
     * We cannot use setClipboard data due to browser compatibility. Also using state to render
     * the input does not work because the copy function does not work during vue js update cycles.
     * For more info please see https://stackoverflow.com/questions/31593297/using-execcommand-javascript-to-copy-hidden-text-to-clipboard
     * @return {Boolean} [the result of the copy]
     */
    copyLinkText() {
      const tempTextarea = document.createElement('textarea');
      tempTextarea.value = this.getLinkText();
      tempTextarea.setAttribute('readonly', '');
      tempTextarea.style.position = 'fixed';
      tempTextarea.style.top = '-9999px';
      document.body.appendChild(tempTextarea);
      tempTextarea.select();
      document.execCommand('copy');
      document.body.removeChild(tempTextarea);
      this.onCopySuccess();
    },

    getLinkText() {
      return this.$refs.link.innerText.trim();
    },
    /**
     * If this is a copy text link, initiate the copy. If not continue with the default action
     * @param  {Object<event>} e [click handler event]
     */
    handleLinkClick(e) {
      if (this.copyOnClick) {
        e.preventDefault();
        this.copyLinkText();
      }
    },
  },
};
</script>

<style scoped module>
@value (greyDark1) from '~css/colors.css';

.copyField {
  position: fixed;
  top: -999px;
}

.link,
.link:focus,
.link:hover {
  color: greyDark1;
}
</style>
